import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import React, {useEffect, useState} from 'react';
import Link from './Link.jsx';

export default function DismissibleNotification() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem('publications-intro-dismissed');
    if (!dismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem('publications-intro-dismissed', 'true');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Container maxWidth="lg" sx={{marginBottom: 2}}>
      <Box
        sx={[
          {
            fontSize: '0.875rem',
            borderRadius: '4px',
            padding: '0.5rem 1rem',
            borderLeft: '4px solid',
            borderLeftColor: 'primary.main',
            backgroundColor: '#f2f2f2',
            position: 'relative',
            paddingRight: '3rem',
          },
          theme =>
            theme.applyStyles('dark', {
              backgroundColor: 'black',
            }),
        ]}
      >
        <IconButton
          onClick={handleDismiss}
          size="small"
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
        Explore the publications database to find scientific papers, conference
        proceedings, and other resources leveraging Planet&apos;s data and
        tools. Note: This list may not be exhaustive and some information may be
        incorrect or missing.
        <Link
          to="https://community.planet.com"
          sx={{display: 'block', marginTop: '5px'}}
        >
          See a missing paper, an error, or want to start a conversation?
        </Link>
      </Box>
    </Container>
  );
}
